import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const PROVIDERS_ENDPOINT = "/provider-invoice";

export class ProviderInvoiceService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE FACTURAS DE PROVEEDORES
     * @EN GETS THE LIST OF PROVIDER INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    listProviderInvoices = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA FACTURA DE PROVEEDOR POR SU ID
     * @EN GETS A PROVIDER INVOICE BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getProviderInvoiceById = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/get",
            data: { id: id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA EL ESTADO DE PAGO DE UNA FACTURA DE PROVEEDOR
     * @EN TOGGLES THE PAID STATUS OF A PROVIDER INVOICE
     */
    // -------------------------------------------------------------------------------------------------------------
    togglePaidStatus = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/toggle-paid",
            data: { id: id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA FACTURA DE PROVEEDOR
     * @EN CREATES A PROVIDER INVOICE
     */
    // -------------------------------------------------------------------------------------------------------------
    createProviderInvoice = async (provider: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/create",
            data: provider,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UNA FACTURA DE PROVEEDOR
     * @EN EDITS A PROVIDER INVOICE
     */
    // -------------------------------------------------------------------------------------------------------------
    editProviderInvoice = async (provider: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/edit",
            data: provider,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA FACTURA DE PROVEEDOR
     * @EN DELETES A PROVIDER INVOICE
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteProviderInvoice = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/delete",
            data: { id: id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS FACTURAS DE PROVEEDOR
     * @EN DELETES MULTIPLE PROVIDER INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiProviderInvoice = async (ids: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/delete-multi",
            data: { 
                ids:ids
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE FACTURAS DE PROVEEDOR PARA UN SELECT
     * @EN GETS THE LIST OF PROVIDER INVOICES FOR A SELECT
     */
    // -------------------------------------------------------------------------------------------------------------
    listProviderInvoiceForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES GENERA FACTURAS AUTOMATICAS
     * @EN GENERATES AUTO INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    generateAutomaticInvoices = async (data: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/generate-automatic-invoices",
            data: data,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES AUTOMATIZA FACTURAS TRIMESTRALES PARA EL AÑO ACTUAL
     * @EN AUTOMATES QUARTERLY BILLING FOR THE CURRENT YEAR
     */
    // -------------------------------------------------------------------------------------------------------------
    automateQuarterlyBilling = async (data: { year?: number; company?: string; invoiceDate: string }) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/automate-quarterly-billing-current-year",
            data,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES DESCARGAR FACTURAS
     * @EN DOWNLOAD INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    downloadMultiProviderInvoice = async (ids: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/download-multiple",
            data: { 
                ids:ids
            },
            responseType: 'blob',
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES DESCARGAR FACTURAS
     * @EN DOWNLOAD INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    downloadProviderInvoice = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/download",
            data: { 
                id:id
            },
            responseType: 'blob',
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES MARCA COMO PAGADAS VARIAS FACTURAS DE PROVEEDOR
     * @EN MARKS AS PAID MULTIPLE PROVIDER INVOICES
     */
    // -------------------------------------------------------------------------------------------------------------
    markAsPaidMultipleProviderInvoices = async (ids: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PROVIDERS_ENDPOINT + "/toogle-paid-multi",
            data: { 
                ids:ids
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
    

}
